import 'COMMON';
import 'Vendor/polifill-object-fit-images/polifill-object-fit-images';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { oLike } from 'Lib/like/like';
import 'Lib/js-anchor-link/js-anchor-link';
import 'Bem/site/books-slider/books-slider';
import 'Bem/journal/articles/articles';
import 'Bem/site/menu-touch/menu-touch';
import 'Bem/site/switchbox/switchbox';
import 'Bem/site/book/book';
import 'Bem/site/authors-slider/authors-slider';
import 'Bem/site/collections-slider/collections-slider';
import { eventSender } from 'Lib/event-sender/event-sender';
import 'Bem/site/search-content/search-content';
import 'Bem/site/author-news-block/author-news-block';

const $body = $('body');

if ($body.find('.sph_no_found').length) {
    eventSender.customDL({
        event: 'eksmo',
        eventAction: 'search',
        eventCategory: decodeURI(window.location.search.replace('?q=', '')),
        eventLabel: 'BadSearch',
    });
}

svgSpriteLoader('/site/search/svg/sprite.svg?v=20190219');
oLike.init('.js-book-like, .js-article-like, .js-author-like');

$body.on('eksmoPagenavAjax', () => {
    oLike.init('.js-book-like, .js-article-like, .js-author-like');
});